import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['warning', 'total']
  static values = { existing: Number, authorized: Number, currency: String, exponent: Number }

  connect() {
    this.check()
  }

  check() {
    const factor = 10 ** this.exponentValue
    const inputs = [...this.element.querySelectorAll('input[name*="[amount]"]')]
    inputs.forEach((input) => this.normalize(input))
    const entered = inputs
      .map((input) => Math.round(parseFloat(input.value) * factor))
      .filter((cents) => !isNaN(cents))
      .reduce((sum, cents) => sum + cents, 0)
    const total = this.existingValue + entered

    this.totalTarget.textContent = this.format(total / factor, total % factor === 0)
    this.warningTarget.classList.toggle('hidden', total === this.authorizedValue)
  }

  // Mirrors Money#iso_format: "EUR 1,000.12" with a non-breaking space, no decimals when whole.
  format(amount, whole) {
    const digits = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: whole ? 0 : this.exponentValue,
      maximumFractionDigits: this.exponentValue
    }).format(amount)
    return `${this.currencyValue}\u00A0${digits}`
  }

  // Accepts dot or comma as the decimal separator, keeps only the first one, and caps decimals at the currency exponent.
  normalize(input) {
    const cleaned = input.value.replace(/[^\d.,]/g, '')
    const separator = cleaned.search(/[.,]/)
    const whole = separator === -1 ? cleaned : cleaned.slice(0, separator)
    const fraction = separator === -1 ? '' : cleaned.slice(separator + 1).replace(/[.,]/g, '').slice(0, this.exponentValue)
    const value = separator === -1 || this.exponentValue === 0 ? whole : `${whole}.${fraction}`
    if (input.value === value) return

    const cursor = Math.max(0, input.selectionStart - (input.value.length - value.length))
    input.value = value
    input.setSelectionRange(cursor, cursor)
  }
}
